import { Box, Button, H3, Stack } from "@adfenix/alexandria";
import CheckCircle2 from "static/svg/check-circle2";
import { State } from "./interfaces";
import { useTranslation } from "react-i18next";

const SuccessPage = ({
  setActiveState
}: {
  setActiveState: (state: State) => void;
}) => {
  const { t } = useTranslation();
  return (
    <Stack spacing="xs" pY="xl5" pX="xl5">
      <Box style={{ marginBottom: 20 }} display="flex" justifyContent="center">
        <CheckCircle2 />
      </Box>
      <Box display="flex" justifyContent="center">
        <H3>{t("selfonboarding.successPage.success.message")}</H3>
      </Box>
      <Box display="flex" justifyContent="center">
        <Button
          logLabel="selfonboarding-success-ok-button"
          type="button"
          variant="primary"
          onClick={() => {
            setActiveState("loading");
          }}
        >
          {t("selfonboarding.successPage.ok.button")}
        </Button>
      </Box>
    </Stack>
  );
};

export default SuccessPage;
